import * as React from "react";
import { Checkbox, Icon } from "antd";
import { IBaseProps } from "lib/data/interfaces";
import { Requiredness } from "lib/data/model/enumerations";

interface ICoverProps extends IBaseProps {
	showCheckboxes: boolean;
	disabledCheckboxes?: boolean;
	requiredness?: Requiredness;
	repeatable?: boolean;
	iconType?: string;
	index?: number;
	onChangeRequired?(): void;
	onChangeRepeatable?(): void;
}

export const Cover = (props: ICoverProps) =>
	<div>
		<p className="card-sort-order">{props.index ? props.index + 1 : null}</p>
		<Icon type={props.iconType} className="template-card-icon" />
		{props.showCheckboxes ?
			<div className="template-card-checkboxes" onClick={(e) => e.stopPropagation()}>
				<Checkbox disabled={props.disabledCheckboxes} className="template-card-required" checked={props.requiredness == Requiredness.REQUIRED}
					onChange={props.onChangeRequired}>Required</Checkbox>

				{
					props.repeatable !== undefined
						?
						<Checkbox disabled={props.disabledCheckboxes} className="template-card-repeatable" checked={props.repeatable}
							onChange={props.onChangeRepeatable}>Repeatable</Checkbox>
						:
						null
				}
			</div>
			: null}
	</div>
